<template>
  <v-row class="mx-0 mt-5 mb-4">
    <v-col>
      <v-row>
        <v-col class="pt-0">
          <v-layout align-center mb-5 class="successTitle">
            <div>
              <v-icon x-large color="error">{{ alertIcon }}</v-icon>
            </div>
            <v-flex mx-2 class="title" mt-1>
              <label>{{ expiredTitle }}</label>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col>
          <v-alert color="#3b474c" outlined>
            {{ expiredMessage }}
          </v-alert>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mdiAlertCircleOutline } from "@mdi/js"; //named import for Alert Icon.
import storedData from "constants/storedData";

export default {
  data() {
    return {
      expiredTitle: "",
      expiredMessage: "",
      alertIcon: mdiAlertCircleOutline,
    };
  },

  //activated() instead of created() to update data with keep alive
  async activated() {
    this.expiredTitle = this.$translate("EXPIREDSESSION_TITLE");
    this.expiredMessage = this.$translate("EXPIREDSESSION_MSG");

    //remove all session storage data
    Object.keys(storedData).forEach((key) => {
      sessionStorage.removeItem(storedData[key]);
    });
  },
};
</script>
